<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card text>
          <v-snackbar
            ma-10
            v-model="snackbar"
            :color="snackbarColor"
            :top="true"
            :right="true"
            :timeout="6000"
            absolute
          >
            {{ message }}
            <v-btn
              dark
              text
              @click="snackbar = false"
            >
              CLOSE
            </v-btn>
          </v-snackbar>
          <v-form ref="form" lazy-validation>
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 == 1" step="1" :rules="[() => !errors.has('season')]">Select Organization</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 == 2" step="2" :rules="[() => !errors.has('accountNumber') && !errors.has('accountName') && !errors.has('bankName') && !errors.has('bankSwiftCode') && !errors.has('currency') ]"> Settlement Details</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 == 3" step="3" :rules="[() => !errors.has('accountNumber') && !errors.has('accountName') && !errors.has('bankName') && !errors.has('bankSwiftCode') && !errors.has('currency') ]" >Farmer USD Account Details</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 == 4" step="4" :rules="[() => !errors.has('farmerUsdAccountNumber') && !errors.has('accountName') && !errors.has('bankName') && !errors.has('bankSwiftCode') && !errors.has('currency') ]" >Farmer KES and Cherry </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 == 5" step="5" :rules="[() => !errors.has('farmerKesAccountNumber') && !errors.has('accountName') && !errors.has('bankName') && !errors.has('bankSwiftCode') && !errors.has('currency') ]" >Generate Schedule</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-container grid-list-xl fluid>
                    <v-layout wrap>
                      <v-flex xs6>
                        <v-autocomplete
                          name="organisationName"
                          v-model="organization.organisationName"
                          :items="organizations"
                          item-text="organisationName"
                          item-value='organisationName'
                          @input="updateOrganization"
                          label="Organization"
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          name="season"
                          label="Season"
                          v-model="season"
                          v-validate="'required'"
                          :error-messages="errors.collect('season')">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-card-actions>
                          <v-progress-circular v-show="loader" color="red" size="20" indeterminate ></v-progress-circular>
                          <v-spacer> </v-spacer>
                          <v-btn color="primary" @click="getGrowerDetails()" rounded >Next</v-btn>
                        </v-card-actions>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-container grid-list-xl fluid>
                    <v-layout wrap>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">FCS NON-CHECKOFF ACCOUNT NUMBER:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.nonCheckoffAccount?.accNumber}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">FCS TRANSACTIONAL ACCOUNT NUMBER:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.checkoffAccount?.accNumber}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">FCS NON-CHECKOFF ACCOUNT NAME:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.nonCheckoffAccount?.accName}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">FCS TRANSACTIONAL ACCOUNT NAME:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.checkoffAccount?.accName}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">AVAILABLE BALANCE (USD):</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>${{this.growerDetails?.nonCheckoffAccount?.availableBalance}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">AVAILABLE BALANCE (USD):</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>${{this.growerDetails?.checkoffAccount?.availableBalance}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>

                      <v-flex xs12>
                        <v-card-actions>
                          <v-btn @click="e1 = 1">Back</v-btn>
                          <v-progress-circular v-show="loader" color="red" size="20" indeterminate ></v-progress-circular>
                          <v-spacer> </v-spacer>
                          <v-btn color="primary" @click="e1 = 3" rounded >Next</v-btn>
                        </v-card-actions>

                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-container grid-list-xl fluid>
                    <v-layout wrap>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">FARMER  USD ACCOUNT NUMBER:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.farmerUsdAccount?.accNumber}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>

                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">FARMER USD ACCOUNT NAME:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.farmerUsdAccount?.accName}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>

                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">AVAILABLE BALANCE (USD):</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>${{this.growerDetails?.farmerUsdAccount?.availableBalance}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>

                      <v-flex xs12>
                        <v-card-actions>
                          <v-btn @click="e1 = 2">Back</v-btn>
                          <v-progress-circular v-show="loader" color="red" size="20" indeterminate ></v-progress-circular>
                          <v-spacer> </v-spacer>
                          <v-btn color="primary" @click="e1 = 4" rounded >Next</v-btn>
                        </v-card-actions>

                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>

                <v-stepper-content step="4">
                  <v-container grid-list-xl fluid>
                    <v-layout wrap>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">FARMER  KES ACCOUNT NUMBER:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.farmerKesAccount?.accNumber}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>

                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">FARMER KES ACCOUNT NAME:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.farmerKesAccount?.accName}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>

                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">AVAILABLE BALANCE (KES):</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>Ksh.{{this.growerDetails?.farmerKesAccount?.availableBalance}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs6>
                      </v-flex>
                      <v-flex xs12>
                      </v-flex>
                      <v-flex xs12>
                        <b>COMPUTED CHERRY INFORMATION</b>
                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">TOTAL CHERRY WEIGHT (KGS):</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.totalCherry}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <V-flex xs6>
                      </V-flex>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <span class="">COMPUTED COMMUNAL RATE:</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <!-- Read-only Text Field -->
                            <span><b>{{this.growerDetails?.communalRate}}</b></span>
                          </v-col>
                        </v-row>
                      </v-flex>



                      <v-flex xs12>
                      </v-flex>
                      <v-flex xs12>
                        <b>LOANS TO RECOVER</b>
                      </v-flex>


                      <v-flex xs6>
                        <v-row
                          v-for="(item, index) in loansToRecover"
                          :key="index"
                        >
                          <v-col cols="1">
                            <v-checkbox
                              v-model="item.checked"
                              :label="''"
                              dense
                              hide-details
                              class="ma-0 pa-0"
                            ></v-checkbox>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <span class="">{{item?.loanProduct}} - Ksh {{item?.loanAmount}}</span>
                          </v-col>
                        </v-row>
                      </v-flex>


                      <v-flex xs12>
                        <v-card-actions>
                          <v-btn @click="e1 = 3">Back</v-btn>
                          <v-progress-circular v-show="loader" color="red" size="20" indeterminate ></v-progress-circular>
                          <v-spacer> </v-spacer>
                          <v-btn color="primary" @click="saveCommunalPayment" rounded >Next</v-btn>
                        </v-card-actions>

                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>

                <v-stepper-content step="5">
                  <v-container grid-list-xl fluid>
                    <v-layout wrap>
                      <v-flex xs6>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-btn color="primary" @click="generateSchedule"  >Generate Farmer Payment Schedule</v-btn>
                          </v-col>

                        </v-row>
                      </v-flex>
                      <v-flex xs6>
                        <v-row>
                            <v-col cols="12" sm="6">

                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-btn color="primary"  v-if="pivotedData.length>0" @click="exportExcel" >Download</v-btn>
                          </v-col>
                        </v-row>
                      </v-flex>
                      <v-flex xs12>
                        <v-row>
                            <v-card  max-width="100%">
                              <v-card-title class="accent--text" style="font-size: 14px; font-weight:700;">Farmer Payment Schedule</v-card-title>
                              <!-- Simple Table -->
                              <table class="table" v-if="pivotedData.length">
                                <thead class="thead">
                                <tr >
                                  <th scope="col">Farmer Name</th>
                                  <th scope="col">National id</th>
                                  <th scope="col">Member Number</th>
                                  <th scope="col">Weight</th>

                                  <th scope="col">Communal Rate</th>
                                  <th scope="col">Total Amount</th>
                                  <th v-for="loanType in loanTypes" :key="loanType" >
                                    {{ loanType }}
                                  </th>
                                  <th scope="col">Net Amount</th>

                                  <th scope="col">Payment Cycle</th>
                                  <th scope="col">Pay Channel</th>
                                  <th scope="col">Account</th>
                                  <th scope="col">Status</th>

                                </tr>
                                </thead>
                                <tbody>
<!--                                <tr v-for="farmer in farmers" :key="farmer.id">-->
<!--                                  <td>{{ farmer.name }}</td>-->
<!--                                  <td>{{ farmer.accountNumber }}</td>-->
<!--                                  <td>{{ farmer.totalAmount }}</td>-->
<!--                                  <td>{{ farmer.status }}</td>-->
<!--                                </tr>-->
                                  <tr v-for="farmerScheduleRecord in filteredList" v-bind:key="farmerScheduleRecord.id">
                                  <td>{{ farmerScheduleRecord.name }}</td>
                                  <td>{{ farmerScheduleRecord.farmerId }}</td>
                                  <td>{{ farmerScheduleRecord.memberNumber }}</td>
                                  <td>{{ farmerScheduleRecord.totalCherryWeight }}</td>

                                  <td>{{ farmerScheduleRecord.commissionRate }}</td>
                                  <td>{{ farmerScheduleRecord.initialAmount }}</td>
                                    <td
                                      v-for="loanType in loanTypes"
                                      :key="loanType"
                                    >
                                      {{ farmerScheduleRecord[loanType] ?? 0 }}
                                    </td>
                                  <td>{{ farmerScheduleRecord.netAmount }}</td>

                                  <td>{{ farmerScheduleRecord.cycle }}</td>
                                  <td>{{ farmerScheduleRecord.institutionType }}</td>
                                  <td>{{ farmerScheduleRecord.accountNumber }}</td>
                                  <td>{{ farmerScheduleRecord.status }}</td>
                                </tr>
                                </tbody>
                              </table>

                              <v-card-actions>
                                <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
                                <v-spacer></v-spacer>
                                <v-pagination
                                  v-model="page"
                                  :length="numberOfLinks"
                                  color="secondary"
                class="accent--text logoutbtn"
                                ></v-pagination>
                              </v-card-actions>
                            </v-card>

                        </v-row>
                      </v-flex>

                      <v-flex xs12>
                        <v-card-actions>
                          <v-progress-circular v-show="loader" color="red" size="20" indeterminate ></v-progress-circular>
                          <v-spacer> </v-spacer>
                          <v-btn color="primary" @click="e1 = 1"  rounded >Close</v-btn>
                        </v-card-actions>

                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import { Validator } from 'vee-validate'
import store from '@/store'
import * as XLSX from "xlsx";

export default {
	name: 'createorganization',
	data: function () {
		return {
      loanTypes:[],
      pivotedData: [],
			organization: {
				organisationName: '',
				organisationCode: '',
				id: ''
			},

			organisation: {
				organisationName: '',
				organisationCode: '',
				organisationTypeId: '',
				identificationDocumentID: '',
				dateOfIncorporation: '',
				address: '',
				postalCode: '',
				settlementAccount: {},
				millerId: '',
				brokerId: '',
				warehouseId: '',
				kraPin: '',
				vatApplic: '',
				vatRate: ''
			},
			loader: false,
			bank: {
				bankName: '',
				bankSwiftCode: '',
				bankCode: '',
				pic: ''
			},
			defaultForm: Object.assign({}, this.organization),
			organizations: [],
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 10,
      page: 1,
      search: '',
			growerDetails: {
				growerCode: '',
				nonCheckoffAccount: {},
				checkoffAccount: {},
				farmerUsdAccount: {},
				farmerKesAccount: {},
				totalCherry: '',
				communalRate: ''
			},
			commId: '',
			farmerSchedule: [],
			farmerScheduleRecord: {
				id: '',
				name: '',
				farmerId: '',
				memberNumber: '',
				totalCherryWeight: '',
				commissionRate: '',
				comId: '',
				cycle: '',
				institutionType: '',
				accountNumber: '',
				status: '',
				initialAmount: '',
				loan: '',
				netAmount: ''
			},
			institutionTypes: [],
			growerCode: '',
			season: '',
			identificationDocuments: [],
			message: '',
			snackbar: false,
			snackbarColor: '',
			startDateMenu: false,
			startDate: null,
			orgId: 0,
			e1: 1,
			currencies: [],
			farmersocieties: [],
			isChild: false,
			millers: [],
			warehouse: [],
			brokers: [],
			banks: [],
      loansToRecover:[],
      selectedLoans:[],
      selectedLoanIds: [],
			isBank: ' ',
      isValid: true
		}
	},
	mounted () {
		this.isBank = store.state.user.organisation.organisationType.name.trim() === 'COOP BANK'
		this.getOrganizations()
		// this.getGrowerDetails ()
		this.getInstitutionTypes()
    this.getExtraColumns();
		this.getCurrencies()
		this.getFcs()
		this.getMillers()
		this.getWarehouse()
		this.getBrokers()

		this.getBanks()
		Validator.extend('no-1234', {
			validate: value => value !== '02320750011234',
			getMessage: field => `${field} cannot be "02320750011234"`
		})
	},
  computed:{
    filteredList: function () {
      if (this.search === '') {
        return this.paginatedFiles
      } else {
        return this.pivotedData.filter(farmerSchedule => {
          return farmerSchedule?.accountName?.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },
  },
  watch: {
    pivotedData () {
      this.paginatedFiles = this.paginationMethod(this.pivotedData, 1, this.numberOfItemsPerPage)
      this.numberOfLinks = Math.ceil(this.pivotedData.length / this.numberOfItemsPerPage)
    },
    page: function (val) {
      this.paginatedFiles = this.paginationMethod(this.pivotedData, val, this.numberOfItemsPerPage)
    }
  },
	methods: {

    getExtraColumns() {
      // Suppose this is your function's output
      const additionalKeys = ['bonus', 'transportCost'];

      this.extraColumns = additionalKeys.map(key => ({
        key,
        label: this.formatColumnLabel(key) // e.g. bonus => Bonus
      }));
    },
    formatColumnLabel(key) {
      return key.replace(/([A-Z])/g, ' $1') // handle camelCase
        .replace(/^./, str => str.toUpperCase()); // capitalize
    },
		// 	validateAccountNumber(account,noncheckoff,orgType) {
		//   // Custom validation logic for account number
		//   console.log('OrgType',orgType)
		//   console.log('OrgType',account)
		//   console.log('OrgType',noncheckoff)
		//   if(orgType!== 4){
		// 	console.log('1')
		// 	if (account === '02320750011234') {
		//     return false; // Validation fails
		//   }else if(noncheckoff === '02320750011234'){
		// 	console.log('2')
		// 	return false
		//   }
		//  // Validation passes
		//   }else{
		// 	console.log('3')
		// 	if (account === '02320750011234') {
		//     return false;
		//   }
		// //   return true;

		// }},
		ifBankUser () {
			return (this.isBank)
		},
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
		getOrganizations () {
			const url = config.serverURI + '/organization/getAll'
			axios.get(url)
				.then(response => {
					console.log('org response', response.data)
					this.organizations = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},

		updateOrganization () {
			const selectedOrganization = this.organizations.find(organization => organization.organisationName === this.organization?.organisationName)
			if (selectedOrganization) {
				console.log('Organization  Code>>>', selectedOrganization.organisationCode)
				console.log('Organization  Name>>>', selectedOrganization.organisationName)
				this.organization.organisationName = selectedOrganization.organisationName
				this.organization.organisationCode = selectedOrganization.organisationCode
			}
		},
		validateAccountNumber (noncheckoff, account, orgType) {
			// Logging the input parameters for debugging

			// Check if orgType is not 4
			if (orgType !== 4) {
				console.log('OrgType is not 4')
				// If account or noncheckoff matches the invalid value, return false
				if (account !== '02320750011234' && account !== '02320750031234') {
					console.log('1')
					return true
				} else if (noncheckoff !== '02320750011234' && noncheckoff !== '02320750031234') {
					console.log('2')
					return true
				} else if (noncheckoff !== '02320750011234') {
					console.log('3')
					return true
				} else {
					return false
				}
				// Otherwise, validation passes
			} else {
				console.log('OrgType is 4')
				// For orgType 4, only check the account 02320750011234
				if (account !== '02320750011234' && account !== '02320750031234') {
					console.log('3')
					return true
				} else if (account !== '02320750011234') {
					console.log('4')
					return true
				} else {
					// Validation passes for orgType 4
					return false
				}
			}
		},
		checkAccountNumber (noncheckoff, account, orgType) {
			// Logging the input parameters for debugging

			// Check if orgType is not 4
			// If account or noncheckoff matches the invalid value, return false
			if (noncheckoff !== '02320750011234') {
				console.log('Non check off is not dss main')
				if (account !== noncheckoff) {
					console.log('1')
					return true
				} else {
					return false
				}
			} else {
				return false
			}

			// Otherwise, validation passes
		},

		// createOrganization () {
		// 	console.log('Settlement checkoff', this.organisation.settlementAccount.checkoffAccountNumber)
		// 	console.log('Settlement Account', this.organisation.settlementAccount.account)
		// 	if (!this.validateAccountNumber(this.organisation.settlementAccount.account, this.organisation.settlementAccount.checkoffAccountNumber, this.organisation.organisationTypeId)) {
		// 		this.message = 'Checkoff number cannot be 02320750011234 or 02320750031234.'
		// 		this.snackbar = true
		// 		this.snackbarColor = 'error'
		// 		return
		// 	}
		// 	if (!this.checkAccountNumber(this.organisation.settlementAccount.account, this.organisation.settlementAccount.checkoffAccountNumber, this.organisation.organisationTypeId)) {
		// 		this.message = 'Checkoff and noncheckoff accounts cannot be the same or the noncheckoff account cannot be 02320750011234 .'
		// 		this.snackbar = true
		// 		this.snackbarColor = 'error'
		// 		return
		// 	}
		// 	this.$validator.validate().then(result => {
		// 		if (result) {
		// 			const url = config.serverURI + '/organization/create'
		// 			this.organisation.dateOfIncorporation = this.startDate
		// 			const formData = new FormData()
		// 			formData.append('file', this.file)
		// 			formData.append('organisation', JSON.stringify(this.organisation))
		// 			console.log(JSON.stringify(this.organisation))
		// 			axios.post(url, formData)
		// 				.then(response => {
		// 					if (response.data.error !== false) {
		// 						this.message = response.data.message
		// 						this.snackbar = true
		// 						this.snackbarColor = 'error'
		// 						console.log('Error is ' + this.error)
		// 						return
		// 					}
		// 					this.resetForm()
		// 					this.message = response.data.message
		// 					this.snackbar = true
		// 					this.snackbarColor = 'primary'
		// 					this.e1 = 1
		// 					this.$validator.reset()
		// 				})
		// 				.catch(error => {
		// 					console.log('error', error.response)
		// 					this.message = error.response.data.message
		// 					this.snackbar = true
		// 					this.snackbarColor = 'error'
		// 				})
		// 			this.handleFileUpload()
		// 		} else {
		// 			// Validation errors exist, show them to the user
		// 			let errs = ''
		// 			this.$validator.errors.items.forEach(error => {
		// 				// console.error(`Validation error: ${error.field} - ${error.msg}`)
		// 				errs += error.msg
		// 				this.snackbar = true
		// 				this.snackbarColor = 'error'
		// 			})
		// 			this.message = errs
		// 		}
		// 	})
		// },
		getBanks () {
			const url = config.serverURI + '/bank'
			axios.get(url)
				.then(response => {
					this.banks = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		resetForm () {
			this.organization = Object.assign({}, this.defaultForm)
			this.$refs.form.reset()
		},
		getInstitutionTypes () {
			var url = config.serverURI + '/instution/get'
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						console.log('Error is ' + this.error)
						return
					}
					this.institutionTypes = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},

    validateForm(){
      var regex = /^(20\d{2})\/(20\d{2})$/;
      this.isValid = true
      if(!this.season){
        this.isValid = false;
        this.message = 'Please input season'
        this.snackbar = true
        this.snackbarColor = 'error'
      }
      else if(!regex.test(this.season)){
        this.isValid = false;
        this.message = 'Please input valid season format'
        this.snackbar = true
        this.snackbarColor = 'error'
      }
      return this.isValid;
    },

		getGrowerDetails () {
      if(this.validateForm()) {
        var url = config.serverURI + '/payment/getGrowerDetails'
        const data = {
          growerCode: this.organization.organisationCode,
          season: this.season
        }
        axios.post(url, data)
          .then(response => {
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbar = true
              this.snackbarColor = 'error'
              console.log('Error is ' + this.error)
              return
            }
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'primary'
            this.growerDetails = response.data.data
            this.loansToRecover = this.growerDetails?.loans
            console.log('grower info ', this.growerDetails)
            console.log('loans info ', this.loansToRecover)
            this.e1 = 2
            this.$validator.reset()
          })
          .catch(error => {
            console.log('error', error.response)
            this.message = error.response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
          })
      }
		},
		saveCommunalPayment () {
      this.selectedLoanIds =[];
			var url = config.serverURI + '/payment/saveCommunalPayment'
      var loanIds ='';
      if(this.loansToRecover) {
        this.selectedLoans = this.loansToRecover.filter(item => item.checked);
        for (const loanItem of this.selectedLoans) {
          this.selectedLoanIds.push(loanItem.id)
        }
        loanIds = this.selectedLoanIds.join(',')
        console.log("loanIds", loanIds)
      }
      const data = {
				growerCode: this.organization.organisationCode,
				season: this.season,
				commRate: this.growerDetails?.communalRate,
				amount: this.growerDetails?.farmerKesAccount?.availableBalance,
				weight: this.growerDetails?.totalCherry,
        loansToRecover: loanIds

			}
			axios.post(url, data)
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.error)
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.commId = response.data.data?.id
					this.e1 = 5
					this.$validator.reset()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.data.message
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},

		generateSchedule () {
			var url = config.serverURI + '/payment/generateFarmerPaymentSchedule/' + this.commId
			axios.get(url)
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.error)
						return
					}
					this.message = response.data.message
					this.farmerSchedule = response.data.data
          console.log("farmer schedule",this.farmerSchedule)

          const loanTypeSet = new Set(this.farmerSchedule
            .filter(item => item && item.loanType != null)
            .map(item => item.loanType))
          this.loanTypes = Array.from(loanTypeSet)

          const grouped = {}

          this.farmerSchedule.forEach(item => {
            const key = item.farmerId
            if (!grouped[key]) {
              grouped[key] = {
                farmerId: item.farmerId,
                name: item.name,
                memberNumber: item.memberNumber,
                totalCherryWeight: item.totalCherryWeight,
                commissionRate: item.commissionRate,
                initialAmount : item.initialAmount,
                netAmount: item.netAmount,
                cycle: item.cycle,
                institutionType: item.institutionType,
                accountNumber: item.accountNumber,
                status: item.status,
                season: item.season,
                orgName: item.orgName,
                accountName: item.accountName
              }
            }
            // Assign loan amount to loan type column
            console.log("before",item.loanType)
            if(item.loanType) {
              console.log("test null",item.loanType)
              grouped[key][item.loanType] = item.loanAmount
            }
          })

          this.pivotedData = Object.values(grouped)

					this.snackbar = true
					this.snackbarColor = 'primary'
					this.e1 = 5
					this.$validator.reset()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.data.message
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
    exportExcel () {
      // Define worksheet and workbook
      const ws = XLSX.utils.json_to_sheet(this.pivotedData
        //   {
        //     header: Object.keys(this.headers)
        //   }
      )
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

      // Export workbook to file
      XLSX.writeFile(wb,  'Farmer_PaymentSchedule_' + Date.now() + '.xlsx')
    },
		getCurrencies () {
			var url = config.serverURI + '/organization/currency'
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						console.log('Error is ' + this.error)
						return
					}
					this.currencies = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		// getOrganisations: function () {
		//   const url = config.serverURI + '/organization/getActiveOrganisations'
		//   axios.get(url)
		//     .then(response => {
		//       this.organisations = response.data
		//       for (const org of this.organisations) {
		//         if (org.organisationType.name === 'MILLER') {
		//           this.millerOrganisations.push(org)
		//         } else if (org.organisationType.name === 'MARKETER') {
		//           this.brokerOrganisations.push(org)
		//         } else if (org.organisationType.name === 'WAREHOUSE') {
		//           this.warehouseOrganisations.push(org)
		//         }
		//       }
		//     })
		//     .catch(error => {
		//       this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
		//     })
		//   return this.organisations
		// },
		getMillers: function () {
			const url = config.serverURI + '/organization/getMillers'
			axios.post(url)
				.then(response => {
					this.millers = response.data
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			return this.organisations
		},
		getBrokers: function () {
			const url = config.serverURI + '/organization/getBrokers'
			axios.post(url)
				.then(response => {
					this.brokers = response.data
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			return this.organisations
		},
		getWarehouse: function () {
			const url = config.serverURI + '/organization/getWarehouse'
			axios.post(url)
				.then(response => {
					this.warehouse = response.data
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			return this.organisations
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		uploadLogo () {
			console.log(this.file)
			const url = config.serverURI + '/organization/' + this.orgId + '/uploadlogo'
			const formData = new FormData()
			formData.append('file', this.file)
			axios.post(url, formData)
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.handleFileUpload()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.data.message
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		getFcs () {
			const url = config.serverURI + '/organization/get-fcs'
			axios.get(url)
				.then(response => {
					this.farmersocieties = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		// updateSwiftCode () {
		// 	// Find the selected bank
		// 	const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.settlementAccount.bankName)
		//
		// 	// Update the bank Swift Code
		// 	if (selectedBank) {
		// 		this.bank.bankSwiftCode = selectedBank.bankSwiftCode
		// 		this.organisation.settlementAccount.bankCode = selectedBank.bankSwiftCode
		// 		this.bank.pic = selectedBank.pic
		// 		if (this.bank.pic === '0011') {
		// 			this.loader = true
		// 			const url = config.serverURI + '/organization/validateAccountDetails'
		// 			const data = {
		// 				organisationType: this.organisation.organisationTypeId,
		// 				accountNumber: this.organisation.settlementAccount.account
		//
		// 			}
		//
		// 			axios.post(url, data)
		// 				.then(response => {
		// 					this.loader = false
		// 					console.log('validationzz response ', response)
		// 					if (response.data.accountName === null) {
		// 						this.message = 'Account Details Missing'
		// 						this.snackbar = true
		// 						this.snackbarColor = 'error'
		// 						this.organisation.settlementAccount.accountName = ''
		// 						console.log('Error is Account Details Missing')
		// 						return
		// 					}
		// 					this.message = 'Account Details validated successfully. '
		// 					console.log('registrationResponse ', response.data.registrationResponse.trim())
		// 					// this.message = 'Account Details validated successfully'+ ' ' + response.data.registrationResponse
		// 					if (response.data.registrationResponse.trim() == 'Account Enrolled successfully for the alert' ||
		//             response.data.registrationResponse.trim() == 'Alert registration successful') {
		// 						this.message += 'Account alert registered successfully.'
		// 						console.log('one')
		// 					} else if (response.data.registrationResponse.trim() == 'Account Already registered for the alert and channelID selected update will be done') {
		// 						this.message += 'Account already registered for alerts.'
		// 						console.log('one2')
		// 					} else {
		// 						this.message += 'Account not registered for alerts.'
		// 						console.log('one3')
		// 					}
		// 					console.log('message ', this.message)
		// 					this.snackbar = true
		// 					this.snackbarColor = 'primary'
		// 					this.organisation.settlementAccount.accountName = response.data.accountName
		// 				})
		// 				.catch(error => {
		// 					this.loader = false
		// 					console.log('error', error.response)
		// 					this.message = error.response.message
		// 					this.snackbar = true
		// 					this.snackbarColor = 'error'
		// 				})
		// 		} else {
		// 			const url = config.serverURI + '/organization/validateIpslAccountDetails'
		// 			console.log(this.bank.pic)
		// 			axios.post(url, { accountNumber: this.organisation.settlementAccount.account, pic: this.bank.pic })
		// 				.then(response => {
		// 					if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
		// 						this.message = 'Account Details Missing'
		// 						this.organisation.settlementAccount.accountName = ''
		// 						this.snackbar = true
		// 						this.snackbarColor = 'error'
		// 						console.log('Error is Account Details Missing')
		// 						return
		// 					}
		// 					this.message = 'Account Details validated successfully'
		// 					this.snackbar = true
		// 					this.snackbarColor = 'primary'
		// 					this.organisation.settlementAccount.accountName = response.data.accountName
		// 				})
		// 				.catch(error => {
		// 					console.log('error', error.response)
		// 					this.message = error.response.message
		// 					this.snackbar = true
		// 					this.snackbarColor = 'error'
		// 				})
		// 		}
		// 	} else {
		// 		this.organisation.settlementAccount.bankCode = '' // Reset if the bank is not found
		// 	}
		// },
		validateAccountNumber (value) {
			if (!value) {
				return 'Account number is required.'
			}
			if (!value.startsWith('02')) {
				return 'Valid dollar accounts start with 02.'
			}
			return true
		},
		checkoffUpdateSwiftCode () {
			// Find the selected bank
			const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.settlementAccount.checkoffBankName)

			// Update the bank Swift Code
			if (selectedBank) {
				this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				this.organisation.settlementAccount.checkoffBankSwiftCode = selectedBank.bankSwiftCode
				this.bank.pic = selectedBank.pic
				if (this.bank.pic === '0011') {
					const data = {
						organisationType: 0,
						accountNumber: this.organisation.settlementAccount.checkoffAccountNumber

					}
					const url = config.serverURI + '/organization/validateAccountDetails'

					console.log('The checkoff account being validate', this.organisation.settlementAccount.checkoffAccountNumber)

					axios.post(url, data)
						.then(response => {
							if (response.data.accountName === null) {
								this.message = 'Account Details Missing'
								this.snackbar = true
								this.snackbarColor = 'error'
								this.organisation.settlementAccount.checkoffAccountName = ''
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.settlementAccount.checkoffAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				} else {
					const url = config.serverURI + '/organization/validateIpslAccountDetails'
					console.log(this.bank.pic)
					axios.post(url, { accountNumber: this.organisation.settlementAccount.account, pic: this.bank.pic })
						.then(response => {
							if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								this.message = 'Account Details Missing'
								this.organisation.settlementAccount.checkoffAccountName = ''
								this.snackbar = true
								this.snackbarColor = 'error'
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.settlementAccount.checkoffAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				}
			} else {
				this.organisation.settlementAccount.bankCode = '' // Reset if the bank is not found
			}
		},

		farmerUsdUpdateSwiftCode () {
			// Find the selected bank
			const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.settlementAccount.farmerUsdBankName)

			// Update the bank Swift Code
			if (selectedBank) {
				this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				this.organisation.settlementAccount.farmerUsdBankSwiftCode = selectedBank.bankSwiftCode
				this.bank.pic = selectedBank.pic
				if (this.bank.pic === '0011') {
					const data = {
						organisationType: 0,
						accountNumber: this.organisation.settlementAccount.farmerUsdAccountNumber

					}
					const url = config.serverURI + '/organization/validateAccountDetails'

					console.log('The farmerUsd account being validate', this.organisation.settlementAccount.farmerUsdAccountNumber)

					axios.post(url, data)
						.then(response => {
							if (response.data.accountName === null) {
								this.message = 'Account Details Missing'
								this.snackbar = true
								this.snackbarColor = 'error'
								this.organisation.settlementAccount.farmerUsdAccountName = ''
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.settlementAccount.farmerUsdAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				} else {
					const url = config.serverURI + '/organization/validateIpslAccountDetails'
					console.log(this.bank.pic)
					axios.post(url, { accountNumber: this.organisation.settlementAccount.farmerUsdAccountNumber, pic: this.bank.pic })
						.then(response => {
							if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								this.message = 'Account Details Missing'
								this.organisation.settlementAccount.farmerUsdAccountName = ''
								this.snackbar = true
								this.snackbarColor = 'error'
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.settlementAccount.farmerUsdAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				}
			} else {
				this.organisation.settlementAccount.bankCode = '' // Reset if the bank is not found
			}
		},

		farmerKesUpdateSwiftCode () {
			// Find the selected bank
			const selectedBank = this.banks.find(bank => bank.bankName === this.organisation.settlementAccount.farmerKesBankName)

			// Update the bank Swift Code
			if (selectedBank) {
				this.bank.bankSwiftCode = selectedBank.bankSwiftCode
				this.organisation.settlementAccount.farmerKesBankSwiftCode = selectedBank.bankSwiftCode
				this.bank.pic = selectedBank.pic
				if (this.bank.pic === '0011') {
					const data = {
						organisationType: 0,
						accountNumber: this.organisation.settlementAccount.farmerKesAccountNumber

					}
					const url = config.serverURI + '/organization/validateAccountDetails'

					console.log('The farmerUsd account being validate', this.organisation.settlementAccount.farmerKesAccountNumber)

					axios.post(url, data)
						.then(response => {
							if (response.data.accountName === null) {
								this.message = 'Account Details Missing'
								this.snackbar = true
								this.snackbarColor = 'error'
								this.organisation.settlementAccount.farmerKesAccountName = ''
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.settlementAccount.farmerKesAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				} else {
					const url = config.serverURI + '/organization/validateIpslAccountDetails'
					console.log(this.bank.pic)
					axios.post(url, { accountNumber: this.organisation.settlementAccount.farmerKesAccountNumber, pic: this.bank.pic })
						.then(response => {
							if (response.data.accountName === null || response.data.accountName === 'Whitelist') {
								this.message = 'Account Details Missing'
								this.organisation.settlementAccount.farmerKesAccountName = ''
								this.snackbar = true
								this.snackbarColor = 'error'
								console.log('Error is Account Details Missing')
								return
							}
							this.message = 'Account Details validated successfully'
							this.snackbar = true
							this.snackbarColor = 'primary'
							this.organisation.settlementAccount.farmerKesAccountName = response.data.accountName
						})
						.catch(error => {
							console.log('error', error.response)
							this.message = error.response.message
							this.snackbar = true
							this.snackbarColor = 'error'
						})
				}
			} else {
				this.organisation.settlementAccount.bankCode = '' // Reset if the bank is not found
			}
		}
	}
}

</script>
<style>
</style>
